/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitchStyled from './ToggleSwitchStyled';

const ToggleSwitch = React.forwardRef(({ onChange, checked }, ref) => (
  <ToggleSwitchStyled>
    <div className="toggle-switch">
      <label className="switch">
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={(e) => {
            onChange(e);
          }}
        />
        <div className="slider" />
      </label>
    </div>
  </ToggleSwitchStyled>
));

ToggleSwitch.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default ToggleSwitch;
